import React from 'react';
import { SVGProps } from 'react';
import { clsx } from 'clsx';
import { IconProps, iconVariants } from '../icon';
import '../icon/icon.module.scss';
type Props = IconProps & Omit<SVGProps<SVGSVGElement>, keyof IconProps>;
const Check = React.forwardRef<SVGSVGElement, Props>(({ color, size, opacity = 1, className, ...props }, ref) => {
  const classes = clsx(
    iconVariants({
      color,
      size,
    }),
    className,
  );
  const style: React.CSSProperties = {
    '--opacity': opacity,
  };
  return React.cloneElement(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12.78}
      height={9.58}
      fill="none"
      viewBox="0 0 12.78 9.58"
      ref={ref}
      {...props}
    >
      <path fill="currentColor" d="m10.538 0 1.637 1.678-7.987 7.795-4.188-4L1.62 3.78l2.55 2.436z" />
    </svg>,
    {
      role: 'presentation',
      focusable: false,
      className: classes,
      'aria-hidden': true,
      style,
      ...props,
    },
  );
});
Check.displayName = 'Check';
export default Check;
